/* Waitlist client app */
angular.module('widget', [
	'ngRoute',
	'pusher-angular',
	'config',
	'translator',
	'utils',
	'ngSanitize',
	'ngResource',
])

angular.module('widget').config([
	'$routeProvider',
	'$locationProvider',
	function ($routeProvider, $locationProvider) {
		$routeProvider
			//External routes: forces a server page load
			.when('/widget/:venueId/card', {
				templateUrl: '/app/widget/templates/reservationCards',
			})
			.when('/widget/:venueId/terms', {
				templateUrl: '/app/widget/templates/reservationToS',
			})
			.when('/widget/:venueId', {
				templateUrl: '/app/widget/templates/reservationPicker',
			})
			.when('/widget/:venueId/customer', {
				templateUrl: '/app/widget/templates/reservationCadastro',
			})
			.when('/widget/:venueId/success', {
				templateUrl: '/app/widget/templates/reservationConfirmation',
			})
			.when('/widget/:venueId/:sectionId', {
				templateUrl: '/app/widget/templates/reservationPicker',
			})
			.otherwise({ templateUrl: '/app/widget/templates/notfound' })
		// enable HTML5mode to disable hashbang urls
		$locationProvider.html5Mode(true)
	},
])

angular.module('widget').factory('dataFactory', [
	'$http',
	'$location',
	'tgConfig',
	function ($http, $location, tgConfig) {
		$http.defaults.headers.common.apptoken = tgConfig.apptoken
		var urlBase = tgConfig.api + '/'
		urlBase = urlBase.replace('http', $location.protocol())

		var urlBradescoBase = tgConfig.programaMenuApi.host
		// if (tgConfig.isDevelopment) urlBradescoBase = 'http://localhost:8082/api/';
		// else if (tgConfig.isStaging) urlBradescoBase = 'https://programamenustaging.azurewebsites.net/api/';
		// else urlBradescoBase = 'http://programamenu.com/api/';

		var dataFactory = {}

		dataFactory.isDevelopment = function () {
			return urlBradescoBase.indexOf('programamenu.com') === -1
		}

		dataFactory.getBradescoCelebrationsTermsConditionsUrl = function () {
			return urlBradescoBase.substr(0, urlBradescoBase.length - 4) + 'regulamento'
		}

		dataFactory.getReservationAvailability = function (venueId, year, month, day, origin) {
			var httpConfig = {
				method: 'GET',
				url:
					urlBase +
					'ReservationStatus/' +
					venueId +
					'/' +
					year +
					'-' +
					month +
					'-' +
					day +
					'/' +
					origin +
					'/availability'
			}
			return $http(httpConfig)
		}

		dataFactory.getReservationSeats = function (venueId) {
			var httpConfig = {
				method: 'GET',
				url: urlBase + 'Seat/' + venueId
			}

			return $http(httpConfig)
		}

		dataFactory.getCardsBenefitsForVenue = function (_customerId, _venueId, _operatorId, _isCelebrations) {
			var httpConfig = {
				headers: { apptoken: tgConfig.bradescoAppToken },
				method: 'GET'
			}

			if (_operatorId) {
				// Concierge visualization
				httpConfig.url = urlBradescoBase + 'Customer/' + _customerId + '/conciergeBenefits/' + _venueId
			} else if (_isCelebrations) {
				// Celebrations customer visualization
				httpConfig.url = urlBradescoBase + 'Customer/' + _customerId + '/celebrationsBenefits/' + _venueId
			} else {
				// Common customer visualization
				httpConfig.url =
					urlBradescoBase +
					'Customer/' +
					_customerId +
					'/cardsBenefitsForVenue/' +
					_venueId +
					'?multichoice=true'
			}

			return $http(httpConfig)
		}

		dataFactory.getBradescoFutureReservations = function (_customerId, _venueId) {
			var httpConfig = {
				headers: { apptoken: tgConfig.bradescoAppToken },
				method: 'GET'
			}

			httpConfig.url =
				urlBradescoBase + 'Waitlist/futureReservations/venue/' + _venueId + '/customer/' + _customerId

			return $http(httpConfig)
		}

		dataFactory.getBooking = function (queryData) {
			var httpConfig = {
				method: 'GET',
				url: urlBase + 'Reservation/Search/' + queryData.venueId,
				params: { search: queryData.search }
			}

			if (queryData.section) {
				httpConfig.params.section = queryData.section
			}

			if (queryData.year && queryData.month && queryData.day) {
				httpConfig.url += '/' + queryData.year + '/' + queryData.month
				httpConfig.params.day = queryData.day
			} else if (queryData.startDate && queryData.endDate) {
				httpConfig.params.startDate = queryData.startDate
				httpConfig.params.endDate = queryData.endDate
			}

			return $http(httpConfig)
		}

		dataFactory.getCustomer = function (_id, phone, email) {
			var httpConfig = {
				method: 'GET',
				url: urlBase + 'Customer' + (_id ? '/' + _id : ''),
				params: { phone: phone, email: email }
			}

			return $http(httpConfig)
		}

		dataFactory.setReservation = function (
			venueId,
			customer,
			reservation,
			originLabel,
			_operator,
			_isBradesco
		) {
			var reservationUrl = _isBradesco
				? urlBradescoBase + 'Venue/' + venueId + '/Reservation/'
				: urlBase + 'Reservation/' + venueId

			var httpConfig = {
				method: 'POST',
				url: reservationUrl,
				data: {
					customer: customer,
					venue: venueId,
					origin: { label: originLabel.label, app: originLabel.app },
					logs: { actionType: reservation.type == 'Regular' ? 'Add' : 'Request' }, //operator => user
					status: reservation.type == 'Regular' ? 'New' : 'Pending',
					partySize: reservation.partySize.partySize,
					section: reservation.section.id,
					timestamp: reservation.timestamp,
					reservationDay: reservation.reservationDay,
					reservationTime: reservation.reservationTime,
					note: reservation.note,
					benefits: reservation.benefits,
					type: reservation.type,
					lang: reservation.lang,
				}
			}
			if (_isBradesco) httpConfig.headers = { apptoken: tgConfig.bradescoAppToken }

			if (_operator) httpConfig.data.logs.user = _operator

			return $http(httpConfig)
		}

		dataFactory.getReservationWidgetApp = function (venueId) {
			var httpConfig = {
				method: 'GET',
				url: urlBase + 'App',
				params: { label: 'Reservation Widget', venue: venueId, select: 'noteHtml' }
			}

			return $http(httpConfig)
		}

		dataFactory.getAvailabilityForApp = function (venueId, appLabel) {
			var appUrlSuffix
			if (appLabel == 'Bradesco') appUrlSuffix = 'bradesco'
			else if (appLabel == 'Guia Michelin') appUrlSuffix = 'guiaMichelin'
			else if (appLabel == 'Mobits') appUrlSuffix = 'mobits'
			else appUrlSuffix = 'reservationWidget'

			var httpConfig = {
				method: 'GET',
				url: urlBase + 'ReservationStatus/' + venueId + '/availabilityForApp/' + appUrlSuffix
			}

			return $http(httpConfig)
		}

		return dataFactory
	},
])
